import React, { useEffect } from 'react';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import ApiService from '../../services/ApiService';
import helpers from '../AddAnomaly/FileUploader/Helpers';
import useStyles from './styles';

const FileSaver = require('file-saver');

function descendingComparator(var1, var2) {
  if (var2 < var1) {
    return -1;
  }
  if (var2 > var1) {
    return 1;
  }
  return 0;
}
const eventDateFormatter = (date) => {
  if (moment(date, 'DD/MM/YYYY').isValid()) {
    return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
  }
  return date;
};
function itemComparator(a, b, orderBy) {
  if (orderBy === 'invoiceDate') {
    return descendingComparator(new Date(a[orderBy]), new Date(b[orderBy]));
  }
  if (orderBy === 'eventDate') {
    return descendingComparator(
      eventDateFormatter(a[orderBy]),
      eventDateFormatter(b[orderBy]),
    );
  }
  if (orderBy === 'ticketCreationDate') {
    return descendingComparator(
      eventDateFormatter(a[orderBy]),
      eventDateFormatter(b[orderBy]),
    );
  }
  return descendingComparator(a[orderBy], b[orderBy]);
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => itemComparator(a, b, orderBy)
    : (a, b) => -itemComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function InvoiceListBody(props) {
  const {
    page,
    rowsPerPage,
    order,
    orderBy,
    rows,
    ticketDetailsPage,
    wagonDetailsPage,
  } = props;
  const [invoices, setInvoices] = React.useState(rows);
  const [loading, setLoading] = React.useState(false);

  const classes = useStyles();

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  useEffect(() => {
    setInvoices(rows);
  }, [rows]);

  function handleSelectedInvoices(id, selected) {
    const copy = invoices.slice();
    const invoice = copy.find((item) => item.id === id);
    invoice.selected = selected;
    setInvoices(copy);
    const selectedInvoices = copy.filter(
      (selectedInvoice) => selectedInvoice.selected === true,
    );
    props.setSelectedInvoices(selectedInvoices);
  }
  function capitalizeFirstLetter(str) {
    if (str[0] !== undefined && str[0] !== null) {
      return str[0].toUpperCase() + str.slice(1);
    }
    return '';
  }
  function downloadInvoiceFile(filename, invoiceNumber, invoiceDate) {
    setLoading(true);
    ApiService.downloadInvoice(invoiceNumber, invoiceDate)
      .then((response) => {
        const blob = new Blob([helpers.base64toBlob(response.data)], {});
        FileSaver.saveAs(blob, filename);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }
  const dateFormatter = (StringDate) => {
    const isValidDate = Date.parse(StringDate);
    if (Number.isNaN(isValidDate)) {
      return null;
    }
    const date = new Date(StringDate);
    return moment(date).format('DD/MM/YYYY');
  };

  return (
    <TableBody>
      {loading && (
        <Paper
          data-testid="loader"
          elevation={0}
          position="absolute"
          zindex="2"
        >
          <CircularProgress className={classes.loader} />
        </Paper>
      )}
      {stableSort(rows, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          const labelId = `invoices-table-${index}`;
          const key = `row-key-${index}`;
          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={key}
              data-testid="invoice-list"
            >
              {!ticketDetailsPage && !wagonDetailsPage && (
                <TableCell
                  component="th"
                  id={labelId}
                  className={classes.tableCell}
                  scope="row"
                >
                  <Checkbox
                    data-testid="select-checkbox"
                    className={
                      row.selected ? classes.checkboxSelected : classes.checkbox
                    }
                    checked={row.selected || false}
                    onChange={(event) =>
                      handleSelectedInvoices(row.id, event.target.checked)
                    }
                    inputProps={{ 'aria-label': 'select-checkbox' }}
                  />
                </TableCell>
              )}
              {wagonDetailsPage && (
                <TableCell align="left" className={classes.tableCell}>
                  {row.maintenanceTicketNumber}
                </TableCell>
              )}
              <TableCell align="left" className={classes.tableCell}>
                {row.invoiceNumber}
              </TableCell>

              <TableCell align="left" className={classes.tableCell}>
                {row.supplier}
              </TableCell>

              <TableCell align="left" className={classes.tableCell}>
                {capitalizeFirstLetter(row.activityType)}
              </TableCell>

              <TableCell align="left" className={classes.tableCell}>
                {dateFormatter(row.invoiceDate)}
              </TableCell>

              {!ticketDetailsPage && !wagonDetailsPage && (
                <TableCell align="left" className={classes.tableCell}>
                  {row.wagonNumber}
                </TableCell>
              )}

              <TableCell align="left" className={classes.tableCell}>
                {row.attachmentName !== 'Not found' ? (
                  <Button
                    data-testid="download"
                    className={classes.downloadInvoiceFile}
                    onClick={() =>
                      downloadInvoiceFile(
                        row.attachmentName,
                        row.invoiceNumber,
                        row.invoiceDate,
                      )
                    }
                  >
                    {row.attachmentName}
                  </Button>
                ) : (
                  row.attachmentName
                )}
              </TableCell>

              <TableCell align="left" className={classes.tableCell}>
                {typeof row.eventDate === 'string' ||
                row.eventDate instanceof String
                  ? row.eventDate
                  : ''}
              </TableCell>

              <TableCell align="left" className={classes.tableCell}>
                {row.amount} €
              </TableCell>

              {!ticketDetailsPage && !wagonDetailsPage && (
                <TableCell align="left" className={classes.tableCell}>
                  {row.maintenanceTicketNumber}
                </TableCell>
              )}
              {!ticketDetailsPage && !wagonDetailsPage && (
                <TableCell align="left" className={classes.tableCell}>
                  {row.ticketCreationDate}
                </TableCell>
              )}
            </TableRow>
          );
        })}
      {emptyRows > 0 && (
        <TableRow style={{ height: 33 * emptyRows }}>
          <TableCell colSpan={12} />
        </TableRow>
      )}
    </TableBody>
  );
}
